declare global {
  interface Window {
    webengage: IWebengage;
    LEAP_PERFORMANCE_ENTRIES: PerformanceEntry[];
    enableCueAnalyticsLogs: () => void;
    disableCueAnalyticsLogs: () => void;
    MathJax?: IMathJaxConfig;
  }

  interface ImportMeta {
    env: {
      VITE_PUBLIC_URL: string;
      VITE_OPENTOK_JS_URL: string;
    };
  }
}

import 'core-js';
import 'regenerator-runtime/runtime';

import { GTM_KEY } from 'constants/keys';

import { initGlobalMethods } from 'global';
import analytics from 'modules/analytics';
import { initSentry } from 'modules/sentry';
import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';
import { setAppType, setPolyfills } from 'utils';
import { getStudentServiceIdFromCookie } from 'utils/auth';

import App from './app';
import '@cuemath/comps/reset.css';
import './app.css';
import './typeform.css';

initSentry();
setAppType();
setPolyfills();
initGlobalMethods();

TagManager.initialize({
  gtmId: GTM_KEY,
});

const studentServiceId = getStudentServiceIdFromCookie();

if (studentServiceId) {
  analytics.login(studentServiceId, 'STUDENT');
}

ReactDOM.render(<App />, document.getElementById('root'));
